module.exports = __webpack_public_path__ + "img/img-insdisponivel.95a58cc4.png";